import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import '../components/ProductDetails.css';
import { allProducts } from '../data/productData';

const rasiOptions = [
  { value: 'Mesham', label: 'மேஷம் (Mesham - Aries)' },
  { value: 'Rishabam', label: 'ரிஷபம் (Rishabam - Taurus)' },
  { value: 'Mithunam', label: 'மிதுனம் (Mithunam - Gemini)' },
  { value: 'Kadagam', label: 'கடகம் (Kadagam - Cancer)' },
  { value: 'Simmam', label: 'சிம்மம் (Simmam - Leo)' },
  { value: 'Kanni', label: 'கன்னி (Kanni - Virgo)' },
  { value: 'Thulam', label: 'துலாம் (Thulam - Libra)' },
  { value: 'Viruchigam', label: 'விருச்சிகம் (Viruchigam - Scorpio)' },
  { value: 'Dhanusu', label: 'தனுசு (Dhanusu - Sagittarius)' },
  { value: 'Makaram', label: 'மகரம் (Makaram - Capricorn)' },
  { value: 'Kumbam', label: 'கும்பம் (Kumbam - Aquarius)' },
  { value: 'Meenam', label: 'மீனம் (Meenam - Pisces)' }
];

const starOptions = [
  { value: 'Ashwini', label: 'அஸ்வினி (Ashwini)' },
  { value: 'Bharani', label: 'பரணி (Bharani)' },
  { value: 'Karthigai', label: 'கார்த்திகை (Karthigai)' },
  { value: 'Rohini', label: 'ரோகிணி (Rohini)' },
  { value: 'Mrigasheersham', label: 'மிருகசீரிடம் (Mrigasheersham)' },
  { value: 'Thiruvathirai', label: 'திருவாதிரை (Thiruvathirai)' },
  { value: 'Punarpoosam', label: 'புனர்பூசம் (Punarpoosam)' },
  { value: 'Poosam', label: 'பூசம் (Poosam)' },
  { value: 'Ayilyam', label: 'ஆயில்யம் (Ayilyam)' },
  { value: 'Magam', label: 'மகம் (Magam)' },
  { value: 'Pooram', label: 'பூரம் (Pooram)' },
  { value: 'Uthiram', label: 'உத்திரம் (Uthiram)' },
  { value: 'Hastham', label: 'ஹஸ்தம் (Hastham)' },
  { value: 'Chithirai', label: 'சித்திரை (Chithirai)' },
  { value: 'Swathi', label: 'சுவாதி (Swathi)' },
  { value: 'Visakam', label: 'விசாகம் (Visakam)' },
  { value: 'Anusham', label: 'அனுஷம் (Anusham)' },
  { value: 'Kettai', label: 'கேட்டை (Kettai)' },
  { value: 'Moolam', label: 'மூலம் (Moolam)' },
  { value: 'Pooradam', label: 'பூராடம் (Pooradam)' },
  { value: 'Uthradam', label: 'உத்திராடம் (Uthradam)' },
  { value: 'Thiruvonam', label: 'திருவோணம் (Thiruvonam)' },
  { value: 'Avittam', label: 'அவிட்டம் (Avittam)' },
  { value: 'Sathayam', label: 'சதயம் (Sathayam)' },
  { value: 'Poorattathi', label: 'பூரட்டாதி (Poorattathi)' },
  { value: 'Uthirattathi', label: 'உத்திரட்டாதி (Uthirattathi)' },
  { value: 'Revathi', label: 'ரேவதி (Revathi)' }
];

function ProductDetails() {

  const { id } = useParams();

const product = allProducts.find((p) => p.id === parseInt(id, 10));

const basePrice = product
  ? Number(product.price?.replace(/,/g, "") || 0)
  : 0;

  const [activeTab, setActiveTab] = useState('description');
  const [quantity, setQuantity] = useState(1);
  const [activeImage, setActiveImage] = useState(product ? product.images[0] : '');
  const [activeImageIndex, setActiveImageIndex] = useState(0);
  const [archanaDetails, setArchanaDetails] = useState([{ name: '', rasi: '', star: '', gothram: '' }]);
  const [preferredDate, setPreferredDate] = useState('');
  const [preferredTime, setPreferredTime] = useState('');
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    if (product) {
      setActiveImage(product.images[0]);
      setActiveImageIndex(0);
      window.scrollTo(0, 0);
    }
  }, [product]);

  useEffect(() => {
    if (!product) return;

    const interval = setInterval(() => {
      const nextIndex = (activeImageIndex + 1) % product.images.length;
      setActiveImage(product.images[nextIndex]);
      setActiveImageIndex(nextIndex);
    }, 10000);

    return () => clearInterval(interval);
  }, [activeImageIndex, product]);

  useEffect(() => {
    setQuantity(archanaDetails.length);
  }, [archanaDetails]);

  const handleThumbnailClick = (image, index) => {
    setActiveImage(image);
    setActiveImageIndex(index);
  };

  const handleArchanaChange = (index, event) => {
    const values = [...archanaDetails];
    values[index][event.target.name] = event.target.value;
    setArchanaDetails(values);
  };

  const handleAddPerson = () => {
    setArchanaDetails([...archanaDetails, { name: '', rasi: '', star: '', gothram: '' }]);
  };

  const handleRemovePerson = (index) => {
    const values = [...archanaDetails];
    values.splice(index, 1);
    setArchanaDetails(values);
  };

    const handleBuyNow = async () => {
  
    if (!preferredDate || !preferredTime || !archanaDetails[0].name) {
      alert("Please fill in Name, Date, and Time before proceeding.");
      return;
    }
  
    setIsProcessing(true);
  
    const totalPrice = basePrice * archanaDetails.length;
  
    try {
  
      const userDetails = {
        productName: product.name,
        preferredDate,
        preferredTime,
        archanaDetails
      };
  
      const API_BASE_URL =
        process.env.REACT_APP_API_URL || "https://iswaran-node.onrender.com";
  
      const response = await axios.post(`${API_BASE_URL}/pay`, {
        amount: totalPrice,
        type: "service",
        userDetails: userDetails
      });
  
      console.log("Payment API Response:", response.data);
  
      const redirectUrl =
        response?.data?.data?.instrumentResponse?.redirectInfo?.url;
  
      if (redirectUrl) {
        window.location.href = redirectUrl;
      } else {
        console.log("Unexpected response:", response.data);
        alert("Payment initialization failed. Please try again.");
      }
  
    } catch (error) {
  
      console.error("Payment error:", error);
      alert("Something went wrong while initiating payment.");
  
    } finally {
  
      setIsProcessing(false);
  
    }
  };
  if (!product) {
    return (
      <div className="product-details-container">
        <p>Product not found</p>
      </div>
    );
  }

  return (
    <div className="product-details-container">

      <div className="product-details-card">

        <div className="product-images">

          <div className="thumbnails">
            {product.images.map((image, index) => (
              <img
                key={index}
                src={image}
                alt=""
                className={activeImage === image ? "active" : ""}
                onClick={() => handleThumbnailClick(image, index)}
              />
            ))}
          </div>

          <div className="main-image">
            <img src={activeImage} alt={product.name} />
          </div>

        </div>

        <div className="product-info">

          <h2>{product.name}</h2>

          <div className="archana-details">
            <label>Archana Details *</label>

            {archanaDetails.map((person, index) => (

              <div key={index} className="archana-person-form">

                <input
                  type="text"
                  name="name"
                  placeholder="Name"
                  value={person.name}
                  onChange={(e) => handleArchanaChange(index, e)}
                />

                <select
                  name="rasi"
                  value={person.rasi}
                  onChange={(e) => handleArchanaChange(index, e)}
                >
                  <option value="">Select Rasi</option>
                  {rasiOptions.map((option) => (
                    <option key={option.value} value={option.value}>{option.label}</option>
                  ))}
                </select>

                <select
                  name="star"
                  value={person.star}
                  onChange={(e) => handleArchanaChange(index, e)}
                >
                  <option value="">Select Star</option>
                  {starOptions.map((option) => (
                    <option key={option.value} value={option.value}>{option.label}</option>
                  ))}
                </select>

                <input
                  type="text"
                  name="gothram"
                  placeholder="Gothram"
                  value={person.gothram}
                  onChange={(e) => handleArchanaChange(index, e)}
                />

                {index > 0 && (
                  <button type="button" onClick={() => handleRemovePerson(index)}>Remove</button>
                )}

              </div>

            ))}

           <button type="button" onClick={handleAddPerson}>Add Another Person</button>

          </div>

          <div className="preferred-date">

            <label>Preferred Date & Time *</label>

            <input
              type="date"
              value={preferredDate}
              onChange={(e) => setPreferredDate(e.target.value)}
            />

            <input
              type="time"
              value={preferredTime}
              onChange={(e) => setPreferredTime(e.target.value)}
            />

          </div>

          <div className="add-to-cart-section">

            <button
              className="add-to-cart-btn"
              onClick={handleBuyNow}
              disabled={isProcessing}
            >
              ₹{(basePrice * archanaDetails.length).toLocaleString("en-IN")}
              {" "}
              {isProcessing ? "PROCESSING..." : "BUY NOW"}
            </button>

          </div>

        </div>

      </div>

    </div>
  );
}

export default ProductDetails;
